import { render } from "./StudentCounts.vue?vue&type=template&id=5f2c36b1"
import script from "./StudentCounts.vue?vue&type=script&lang=js"
export * from "./StudentCounts.vue?vue&type=script&lang=js"

import "./StudentCounts.vue?vue&type=style&index=0&id=5f2c36b1&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__